import s from './TeamsList.scss'
import MaterialTable from '@material-table/core'

const columns = [
  { title: 'Team Name', field: 'name', defaultSort: 'asc' },
  { title: '3-letter Short Name', field: 'abbreviation' },
  {
    title: '# of users',
    field: 'usersCount'
  }
]

const TeamsList = ({ teams, removeTeam, openEditTeamModal }) => {
  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title="Current Teams:"
        columns={columns}
        data={teams}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={[
          () => ({
            icon: 'edit',
            tooltip: 'Edit Team',
            onClick: (event, rowData) => openEditTeamModal(rowData)
          }),
          () => ({
            icon: 'delete',
            tooltip: 'Delete Team',
            onClick: (event, rowData) => removeTeam(rowData.id, rowData.email)
          })
        ]}
      />
    </div>
  )
}

export default TeamsList
